export default __webpack_public_path__ + "static/media/FoodLuv_Empty.1a6b72ed.png";